import styled from "styled-components";
import { NewsSection } from "../components/news/NewsSection";
import { InstallAppButton } from "../components/InstallAppButton";
import logoSvg from "../assets/logo_black.svg";

const Container = styled.div``;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px 0;
`;

const Logo = styled.img`
  height: auto;
  width: 100%;

  @media (min-width: 768px) {
    height: 200px;
  }
`;

export const Home = () => {
  return (
    <Container>
      <LogoContainer>
        <Logo src={logoSvg} alt="CO2 Snowboarding Logo" />
      </LogoContainer>
      <InstallAppButton />
      <NewsSection />
    </Container>
  );
};
